import CciPageSlide from './slide/CciPageSlide.vue'
import { mapGetters } from 'vuex'
import Swiper from 'swiper/bundle'
import { CciDataSourceUpdatePages, CciDataSourceClearMemory, pages } from 'model/CciDataSource.js'

export default {
  data () {
    return {
      swiper: null,
      pageIsFromSectionsBar: false,
      pageHeight: '',
      swipeCounter: 1,
      didSwipePage: false,
      loadSwiperWithPageIndex: -1,
      isInterstitialInserted: false,
      isShowingInterstitial: false,
      adSlot: null,
      shouldDisplayAd: true,
      pagesLoaded: [],
      pageSlideVirtualData: {
        slides: []
      },
      isReloadData: false
    }
  },
  created () {
    window.addEventListener('resize', this.didResize)
    window.addEventListener("orientationchange", this.orientationDidChange)

    document.addEventListener('fullscreenchange', this.fullscreenChange, false)
    document.addEventListener('mozfullscreenchange', this.fullscreenChange, false)
    document.addEventListener('webkitfullscreenchange', this.fullscreenChange, false)
    document.addEventListener('msfullscreenchange', this.fullscreenChange, false)

    document.addEventListener('keydown', this.checkKeyDown)
  },
  mounted () {
    // this.applySettings(this.settings)
    this.setDisplayOfAds()
    if (this.swiper === null) {
      // This is only necessary when returning to pages from article list.
      // In other cases we initialize the swiper when pages are loaded.
      // Then why don't why always only initialize the swiper here?
      // When the app is loaded for the first time we have to initialize it again when the pages are loaded, because the pages is not ready to be layouted.
      this.setHeightOfPagesContainer()
      this.initializeSwiper()
      var pageNumber = this.$route.params.pageNr
      var pageIndex = this.getIndexForSlideFromRouteParam(pageNumber)
      this.cleanAndResetInterstitials(pageIndex)
      if (this.pages !== undefined && this.pages[pageIndex] !== undefined) {
        var page = this.pages[pageIndex]
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', page.firstPage, page.firstPage.attributes.Page)
        if (page.secondPage !== null) {
          this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', page.secondPage, page.secondPage.attributes.Page)
        }
        this.setCurrentSectionFromPage(page)
      }
    }
  },
  computed: {
    isIE11: function () {
      return !!window.MSInputMethodContext && !!document.documentMode
    },
    totalNumberOfPages: function () {
      if (this.pages[0] !== undefined) {
        if (this.pages[this.pages.length - 1].secondPage !== null) {
          return this.pages[this.pages.length - 1].secondPage.pageNumber
        }
        return this.pages[this.pages.length - 1].firstPage.pageNumber
      }
      return 0
    },
    currentPageNumber: function () {
      if (this.currentPage !== undefined) {
        var firstNumber = this.currentPage.firstPage.pageNumber
        if (this.currentPage.secondPage !== null) {
          var secondNumber = this.currentPage.secondPage.pageNumber
          return firstNumber + '-' + secondNumber
        }
        return firstNumber
      }
    },
    showPrevButton: function () {
      if (this.swiper !== null) {
        return this.swiper.activeIndex !== 0
      }
    },
    showNextButton: function () {
      if (this.swiper !== null) {
        return this.swiper.activeIndex < this.swiper.virtual.slides.length - 1
      }
    },
    ...mapGetters({
      currentSection: 'getCurrentSection',
      currentArticle: 'getCurrentArticle',
      pages: 'getPages',
      sections: 'getSections',
      currentPage: 'getCurrentPage',
      pageFromSection: 'getPageFromSection',
      showScrubber: 'getShowScrubber',
      showIssueOverview: 'getShowIssueOverview',
      showArticleModal: 'getShowArticleModal',
      settings: 'getSettings',
      interstitialsFrequency: 'getInterstitialsFrequency',
      interstitials: 'getInterstitials',
      resetInterstitials: 'getResetInterstitials',
      adsEnabled: 'getAdsEnabled',
      singlePagesNoAds: 'getSinglePagesNoAds',
      isFullPageViewMode: 'getPageViewMode',
    })
  },
  watch: {
    settings: function() {
      // this.applySettings(newValue)
      this.setDisplayOfAds()
    },
    currentPage: function (newValue) {
      // This happens for every page change. Except when navigating from article list!.
      if (newValue.firstPage.interstitialInfo !== undefined && newValue.firstPage.interstitialInfo !== null) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesInterstitialPageView', newValue.firstPage)
      } else {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', newValue.firstPage, newValue.firstPage.attributes.Page)
        if (newValue.secondPage !== null) {
          this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', newValue.secondPage, newValue.secondPage.attributes.Page)
        }
      }

      if (this.swiper !== null && !this.didSwipePage) {
        this.destroyInterstitialAd()
        this.swiper.slideTo(this.pages.indexOf(newValue))
      }
      if (!this.pageIsFromSectionsBar && !newValue.firstPage.isInterstitial) {
        this.setCurrentSectionFromPage(newValue)
      }
      // this.didResize()
      if (newValue.firstPage.interstitialAdAfterPage !== undefined) {
        this.displayInterstitialAd()
      }

      if (this.$store.state.startArticleId != undefined) {
        this.$store.commit('setCurrentArticleFromIds', {'articleId': this.$store.state.startArticleId, 'pageId': undefined})
        this.$store.commit('setShowArticleModal', true)
        this.$store.state.startArticleId = undefined
      }

      // shouldDisplayAd is only relevant on mobile devices where the layout messes up if the first page is not swiped back and forth on load.
      // if (newValue.firstPage.interstitialAdAfterPage !== undefined && this.shouldDisplayAd) {
      //   this.displayInterstitialAd()
      // } else {
      //   this.shouldDisplayAd = true
      // }
    },
    pages: function (newValue, oldValue) {
      if (oldValue.length === 0) {
        // Init
        this.swiper.destroy()
        this.swiper = null
        this.initializeSwiper()
        this.setHeightOfPagesContainer()
      } else {
        // Reload data
        this.isReloadData = true
        let currentPageId = this.swiper.virtual.slides[this.swiper.activeIndex]
        this.loadSwiperWithPageIndex = this.getPageIndexForPageId(currentPageId)
        this.swiper.virtual.removeAllSlides()
        this.$nextTick( function () {
          this.swiper.destroy()
          this.swiper = null
          this.initializeSwiper()
          this.setHeightOfPagesContainer()
        })
      }
    },
    '$route': function (to) {
      var pageNumber = to.params.pageNr
      if (this.swiper !== null) {
        var index = this.getIndexForSlideFromRouteParam(pageNumber)
        if (index !== this.swiper.activeIndex) {
          this.swiper.slideTo(index)
        }
      }
    },
    pageFromSection: function (newValue) {
      this.swipeCounter = 1
      this.pageIsFromSectionsBar = true
      this.$store.commit('setCurrentPage', newValue)
    },
    resetInterstitials: function (newValue) {
      if (newValue) {
        this.cleanAndResetInterstitials()
        this.$store.commit('setResetInterstitials', false)
      }
    },
    isFullPageViewMode: function (newValue, oldValue) {
      // full page change -> reload.
      if (oldValue !== newValue && oldValue !== undefined) {
        this.reloadData(newValue)
      }
    },
    showIssueOverview: function (newValue) {
      if (newValue) {
        document.removeEventListener('keydown', this.checkKeyDown)
      } else {
        document.addEventListener('keydown', this.checkKeyDown)
      }
      if (this.currentPage.firstPage.interstitialAdAfterPage !== undefined) {
        if (newValue) {
          this.destroyInterstitialAd()
        } else {
          this.displayInterstitialAd()
        }
      }
    },
    showArticleModal: function (newValue) {
      if (newValue) {
        document.removeEventListener('keydown', this.checkKeyDown)
      } else {
        document.addEventListener('keydown', this.checkKeyDown)
      }
      if (this.currentPage.firstPage.interstitialAdAfterPage !== undefined) {
        if (newValue) {
          this.destroyInterstitialAd()
        } else {
          this.displayInterstitialAd()
        }
      }
    }
  },
  methods: {
    // applySettings (settings) {
    //   if (settings !== undefined) {
    //     var url = settings.pageNextArrowIconURL
    //     if (url !== '') {
    //       var icon = document.getElementById('next-page-button')
    //       icon.style.background = 'url(' + url + ')'
    //       icon.style.backgroundSize = 'cover'
    //     }
    //
    //     url = settings.pagePrevArrowIconURL
    //     if (url !== '') {
    //       var icon1 = document.getElementById('prev-page-button')
    //       icon1.style.background = 'url(' + url + ')'
    //       icon1.style.backgroundSize = 'cover'
    //     }
    //   }
    // },
    initializeSwiper () {
      if (this.swiper !== null) {
        return
      }
      this.isReloadData = false

      var pagesContainer = document.getElementById('pages-container')
      pagesContainer.addEventListener('swipeToPrevPage', this.swipeToPrevPage)
      pagesContainer.addEventListener('swipeToNextPage', this.swipeToNextPage)

      var initialSlide = 0
      if (this.loadSwiperWithPageIndex !== -1) {
        initialSlide = this.loadSwiperWithPageIndex
        this.loadSwiperWithPageIndex = -1
      } else {
        initialSlide = this.getIndexForSlideFromRouteParam(this.$route.params.pageNr)
      }

      if (initialSlide === undefined) {
        initialSlide = 0
      }

      var self = this
      this.swiper = new Swiper('.pages-swiper-container', {
        wrapperClass: 'pages-swiper-wrapper',
        slideClass: 'pages-swiper-slide',
        spaceBetween: 0,
        simulateTouch: false,
        allowTouchMove: false,
        initialSlide: initialSlide,
        virtual: {
          slides: self.createVirtualPageSlides(),
          renderExternal(data) {
            self.pageSlideVirtualData = data
          }
        },
        slidesPerView: 1
      })

      var pageToInit = this.pages[initialSlide]
      if (pageToInit !== undefined) {
        this.setRouterPage(pageToInit)
        this.$store.commit('setCurrentPage', pageToInit.firstPage)
        this.setCurrentArticleFromPage(pageToInit)
      }

      this.swiper.on('transitionEnd', () => {
        if (this.isReloadData) {
          return
        }
        var page = this.pages[this.swiper.activeIndex]
        if (this.didSwipePage) {
          if (this.interstitials !== undefined && this.swipeCounter === this.interstitialsFrequency && !this.isInterstitialInserted) {
            this.swipeCounter = 1
            this.insertInterstitials(this.swiper.activeIndex)
            // Insert interstitials on prev and next page.
          } else if (this.interstitials !== undefined && this.isInterstitialInserted && page.firstPage.isInterstitial) {
            this.isShowingInterstitial = true
            this.$store.commit('setCurrentPage', page.firstPage)
            this.setRouterPage(page)
            this.setCurrentArticleFromPage(page)
          } else if (this.interstitials !== undefined && this.isInterstitialInserted && this.isShowingInterstitial) {
            this.isShowingInterstitial = false
            this.isInterstitialInserted = false
            this.cleanUpInterstitials(this.swiper.activeIndex)
          } else {
            this.$store.commit('setCurrentPage', page.firstPage)
            this.setRouterPage(page)
            this.setCurrentArticleFromPage(page)
          }
          this.pageIsFromSectionsBar = false
          this.didSwipePage = false
        } else {
          this.$store.commit('setResetInterstitials', true)
          // var page = this.pages[this.swiper.activeIndex]
          this.$store.commit('setCurrentPage', page.firstPage)
          this.setRouterPage(page)
          this.setCurrentArticleFromPage(page)
          this.pageIsFromSectionsBar = false
        }

        let nextPageRef = this.getNextSlideRef()
        let prevPageRef = this.getPrevSlideRef()
        if (nextPageRef !== undefined) {
          nextPageRef.updateShouldScrollToRight(false)
        }
        if (prevPageRef !== undefined) {
          prevPageRef.updateShouldScrollToRight(true)
        }
      })
    },
    setCurrentSectionFromPage (page) {
      this.$store.commit('setCurrentSection', page.firstPage.sections[0])
    },
    setRouterPage (page) {
      if (page === undefined) {
        return
      }
      let pageNumber = page.firstPage.pageNumber
      this.$router.replace({ name: 'pages', params: { pageNr: pageNumber }})
    },
    getPageIndexForPageId (pageId) {
      for (var i = 0; i < this.pages.length; i++) {
        let page = this.pages[i]
        if (page.firstPage.id === pageId) {
          return i
        } else if (page.secondPage !== null && page.secondPage.id === pageId) {
          return i
        }
      }
      return 0
    },
    getIndexForSlideFromRouteParam(pageParam) {
      for (var i = 0; i < this.pages.length; i++) {
        if (this.pages[i].firstPage.pageNumber === pageParam) {
          return i
        } else if (this.pages[i].secondPage !== null && this.pages[i].secondPage.pageNumber === pageParam) {
          return i
        }
      }
    },
    isCurrentArticleOnPage(page) {
      if (page === undefined) {
        return false
      }
      if (page.firstPage.articles.indexOf(this.currentArticle) !== -1) {
        return true
      } else if (page.secondPage !== null && page.secondPage.articles.indexOf(this.currentArticle) !== -1) {
        return true
      }
      return false
    },
    setCurrentArticleFromPage(page) {
      if (page === undefined) {
        return
      }
      if (!this.isCurrentArticleOnPage(page)) {
        var article
        if (page.firstPage.articles.length > 0) {
          article = page.firstPage.articles[0]
        } else if (page.secondPage !== null && page.secondPage.articles.length > 0) {
          article = page.secondPage.articles[0]
        }

        if (article === undefined) {
          let pageIndex = this.pages.indexOf(page)
          article = this.nextArticle(pageIndex)
        }

        this.$store.commit('setCurrentArticle', article)
      }
    },
    nextArticle(pageIndex){
      for (var i = pageIndex; i < this.pages.length; i++) {
        if (this.pages[i].firstPage.articles.length > 0) {
          return this.pages[i].firstPage.articles[0]
        } else if (this.pages[i].secondPage !== null && this.pages[i].secondPage.articles.length > 0) {
          return this.pages[i].secondPage.articles[0]
        }
      }
      return this.previousArticle(pageIndex)
    },
    previousArticle(pageIndex) {
      for (var i = pageIndex; i >= 0; i--) {
        if (this.pages[i].secondPage !== null && this.pages[i].secondPage.articles.length > 0) {
          return this.pages[i].secondPage.articles[0]
        } else if (this.pages[i].firstPage.articles.length > 0) {
          return this.pages[i].firstPage.articles[0]
        }
      }
    },
    isFullscreen () {
      return !(!document.isFullScreen && !document.fullscreenElement && !document.webkitFullscreenElement && !document.mozFullScreenElement && !document.msFullscreenElement)
    },
    setHeightOfPagesContainer() {
      var pageHeight = document.documentElement.clientHeight
      if ((this.settings !== undefined && !this.settings.enableSectionsBar) || this.sections.length <= 1) {
        // No section bar.
        document.getElementById('pages-container').style.marginTop = '53px'
        // height of header = 50px + 3px margin from header to page + 3px margin from page to bottom of view.
        // = 56
        pageHeight = pageHeight - 56
      } else {
        document.getElementById('pages-container').style.marginTop = '0px'
        // height of header and section bar = 88px + 2px margin from section bar to page + 3px margin from page to bottom of view.
        // = 93
        pageHeight = pageHeight - 93
      }

      if (this.isTablet() && this.adsEnabled) {
        pageHeight = pageHeight - 90
      } else if (this.adsEnabled && this.isPhonePortrait()) {
        // Make space for ad in bottom.
        pageHeight = pageHeight - 50
      }

      document.getElementById('pages-container').style.height = pageHeight.toString() + 'px'
      this.pageHeight = pageHeight.toString() + 'px'
      return pageHeight
    },
    checkKeyDown(e) {
      if (!this.showIssueOverview && !this.showArticleModal) {
        e = e || window.event
        if (e.key == 'End') {
          this.swiper.slideTo(this.pages.length - 1)
        } else if (e.key == 'Home') {
          this.swiper.slideTo(0)
        } else if (e.key == 'ArrowLeft') {
          if (this.showPrevButton) {
            this.swipeToPrevPage()
          }
        } else if (e.key == 'ArrowRight') {
          if (this.showNextButton) {
            this.swipeToNextPage()
          }
        }
      }
    },
    didResize(event, forceReload) {
      // this.hidePages()
      if (forceReload) {
        this.hidePages()
        location.reload()
      }

      let isSinglePages = this.isPhone() || (this.isTabletPortrait() && !this.adsEnabled) || this.isPortrait() || !this.isFullPageViewMode

      var doNotReload = false
      if (this.isFullPageViewMode && !isSinglePages) {
        // If in full page view mode then we have to check if there is space enough to show double pages.
        const activeSlide = this.getCurrentSlideRef()
        var pageCont1Width = document.getElementById(activeSlide._uid + 'page-left-container').offsetWidth
        var zoomWrapperWidth = document.getElementById(activeSlide._uid + 'zoom-wrapper').offsetWidth
        if (pageCont1Width === 0) {
          // Sometimes the left page width can be 0. When this happens then we should not reload.
          doNotReload = true
        } else {
          if (pageCont1Width * 2 >= zoomWrapperWidth) {
            // Not enough space in view port to show double pages -> switch to single pages.
            isSinglePages = true
          } else {
            // There is space enough.
            isSinglePages = false
          }
        }
      }

      if (!doNotReload && this.pages !== undefined && this.settings !== undefined && (forceReload || isSinglePages !== this.isCurrentSinglePages())) {
        this.reloadData(this.isFullPageViewMode, isSinglePages)
      } else if (this.pages !== undefined) {
        this.setHeightOfPagesContainer()
      }
    },
    reloadData (isFullPage, isSinglePages) {
      // let isSinglePages = this.isPhone() || (this.isTabletPortrait() && !this.adsEnabled) || this.isPortrait()

      let singlePages = []
      for (var i = 0; i < this.pages.length; i++) {
        singlePages.push(this.pages[i].firstPage)
        if (this.pages[i].secondPage !== null) {
          singlePages.push(this.pages[i].secondPage)
        }
      }

      CciDataSourceUpdatePages(singlePages, isSinglePages, isFullPage)
      this.$store.commit('setPages', pages)
      CciDataSourceClearMemory()
      this.setHeightOfPagesContainer()
    },
    isCurrentSinglePages () {
      var secondPagesExists = false
      for (var i = 0; i < this.pages.length; i++) {
        if (this.pages[i].secondPage !== null) {
          secondPagesExists = true
        }
      }
      return !secondPagesExists
    },
    hidePages() {
      var elements = document.getElementsByClassName('page-left')
      for (var i = 0; i < elements.length; i++) {
        elements[i].style.visibility = 'hidden'
      }
      var elements1 = document.getElementsByClassName('page-right')
      for (var j = 0; j < elements1.length; j++) {
        elements1[j].style.visibility = 'hidden'
      }
    },
    orientationDidChange () {
      this.didResize(null, true)
    },
    swipeToPrevPage () {
      const activeSlide = this.getCurrentSlideRef()
      if (!activeSlide.isPageScrolledToLeft()) {
        if (activeSlide.scrollToLeft()) {
          return
        }
      }
      if (!this.swiper.animating) {
        // this.$store.commit('setZoomScale', 1.0)
        this.didSwipePage = true
        if (this.pages[this.swiper.activeIndex].firstPage.isInterstitial) {
          this.didShowInterstitial(this.pages[this.swiper.activeIndex])
          this.swipeCounter = 1
        }
        this.swipeCounter++
        if (this.pages[this.swiper.activeIndex].firstPage.interstitialAdAfterPage !== undefined) {
          // If the page is changing away from an interstitial ad then destroy the interstitial ad.
          this.destroyInterstitialAd()
        }
        this.swiper.slidePrev()
      }
    },
    swipeToNextPage () {
      const activeSlide = this.getCurrentSlideRef()
      if (!activeSlide.isPageScrolledToRight()) {
        if (activeSlide.scrollToRight()) {
          return
        }
      }
      if (!this.swiper.animating) {
        // this.$store.commit('setZoomScale', 1.0)
        this.didSwipePage = true
        if (this.pages[this.swiper.activeIndex].firstPage.isInterstitial) {
          this.didShowInterstitial(this.pages[this.swiper.activeIndex])
          this.swipeCounter = 1
        }
        this.swipeCounter++
        if (this.pages[this.swiper.activeIndex].firstPage.interstitialAdAfterPage !== undefined) {
          // If the page is changing away from an interstitial ad then destroy the interstitial ad.
          this.destroyInterstitialAd()
        }
        this.swiper.slideNext()
      }
    },
    getArticleInCenter () {
      const activeSlide = this.getCurrentSlideRef()
      return activeSlide.getArticleInCenter()
    },
    getZoomScale () {
      const activeSlide = this.getCurrentSlideRef()
      if (activeSlide.zoomer === null) {
        return 1.0
      }
      return activeSlide.zoomer.scale
    },
    getCurrentSlideRef () {
      let currentPageId = this.swiper.virtual.slides[this.swiper.activeIndex]
      for (var key in this.$refs) {
        if (Object.prototype.hasOwnProperty.call(this.$refs, key)) {
          let ref = this.$refs[key][0]
          if (ref.$vnode.data.key === currentPageId) {
            return ref
          }
        }
      }
    },
    getNextSlideRef () {
      let currentPageId = this.swiper.virtual.slides[this.swiper.activeIndex + 1]
      if (currentPageId === undefined) {
        return
      }
      for (var key in this.$refs) {
        if (Object.prototype.hasOwnProperty.call(this.$refs, key)) {
          let ref = this.$refs[key][0]
          if (ref.$vnode.data.key === currentPageId) {
            return ref
          }
        }
      }
    },
    getPrevSlideRef () {
      let currentPageId = this.swiper.virtual.slides[this.swiper.activeIndex - 1]
      if (currentPageId === undefined) {
        return
      }
      for (var key in this.$refs) {
        if (Object.prototype.hasOwnProperty.call(this.$refs, key)) {
          let ref = this.$refs[key][0]
          if (ref.$vnode.data.key === currentPageId) {
            return ref
          }
        }
      }
    },
    insertInterstitials (pageIndex) {
      if (this.interstitials === undefined) {
        return
      }
      this.isInterstitialInserted = true

      // TEST
      // var interstitial1 = this.interstitials[0]
      // var interstitial2 = this.interstitials[1]

      var sectionForFirstpage = this.pages[pageIndex].firstPage.sections[0]
      var sectionForSecondPage = null
      if (this.pages[pageIndex].secondPage !== null) {
        sectionForSecondPage = this.pages[pageIndex].secondPage.sections[0]
      }

      // interstitial1 will be inserted on previous page
      var interstitial1 = this.interstitials[0].leftInterstitial
      // interstitial1 will be inserted on next page
      var interstitial2 = this.interstitials[0].rightInterstitial

      // If one of the pages showing belongs to a section.
      if (sectionForFirstpage !== null || sectionForSecondPage !== null) {
        for (var i = 0; i < this.interstitials.length; i++) {
          var interstitial = this.interstitials[i]
          // If first page belongs to a section.
          if (sectionForFirstpage !== null) {
            if (interstitial.section.id === sectionForFirstpage.id) {
              // We found an interstitial with matching section.
              if (sectionForSecondPage === null) {
                // Second page does not belong to a section or only one page is visible.
                // Set the two interstitials to show.
                interstitial1 = interstitial.leftInterstitial
                interstitial2 = interstitial.rightInterstitial
              } else {
                // Second page belongs to a section.
                // Only set the previous interstitial.
                interstitial1 = interstitial.leftInterstitial
              }
            }
          }
          if (sectionForSecondPage !== null) {
            // Second page belongs to a section.
            if (interstitial.section.id === sectionForSecondPage.id) {
              // We found an interstitial with matching section.
              // Set the next interstitial
              interstitial2 = interstitial.rightInterstitial
            }
          }
        }
      }

      var newPagesArray = this.pages
      this.loadSwiperWithPageIndex = pageIndex + 1

      if (pageIndex > 0 && pageIndex < this.pages.length - 1) {
        newPagesArray.splice(pageIndex, 0, interstitial1)
        newPagesArray.splice(pageIndex + 2, 0, interstitial2)
      } else if (pageIndex === 0) {
        newPagesArray.splice(pageIndex + 1, 0, interstitial2)
        this.loadSwiperWithPageIndex = pageIndex
      } else if (pageIndex === this.pages.length - 1) {
        newPagesArray.splice(pageIndex, 0, interstitial1)
      }

      this.$store.commit('setPages', newPagesArray)
    },
    cleanUpInterstitials (pageIndex) {
      var currentPage = this.pages[pageIndex]

      var newPagesArray = this.pages
      for (var i = 0; i < this.pages.length; i++) {
        var page = this.pages[i]
        if (page.firstPage.isInterstitial === true) {
          var pageIndex1 = this.pages.indexOf(page)
          if (pageIndex1 != -1) {
            newPagesArray.splice(pageIndex1, 1)
          }
        }
      }

      this.loadSwiperWithPageIndex = newPagesArray.indexOf(currentPage)
      this.$store.commit('setPages', newPagesArray)
    },
    cleanAndResetInterstitials (pageIndex) {
      this.cleanUpInterstitials(pageIndex)
      this.loadSwiperWithPageIndex = -1
      this.swipeCounter = 1
      this.isInterstitialInserted = false
      this.isShowingInterstitial = false
    },
    didShowInterstitial(interstitialPage) {
      var interstitialIndex = 0
      for (var i = 0; i < this.interstitials.length; i++) {
        if (this.interstitials[i].leftInterstitial.firstPage.id === interstitialPage.firstPage.id
          || this.interstitials[i].rightInterstitial.firstPage.id === interstitialPage.firstPage.id) {
          interstitialIndex = i
          break
        }
      }

      var shiftInterstitials = this.interstitials
      if (interstitialIndex != -1) {
        var interstitial = shiftInterstitials[interstitialIndex]
        shiftInterstitials.splice(interstitialIndex, 1)
        shiftInterstitials.push(interstitial)
        this.$store.commit('setInterstitials', shiftInterstitials)
      }
    },
    setDisplayOfAds () {
      var pagesContainer = document.getElementById('pages-container')
      var prevPageBut = document.getElementsByClassName('page-prev')[0]
      var pageNavBut1 = document.getElementsByClassName('page-nav')[0]
      var pageNavBut2 = document.getElementsByClassName('page-nav')[1]
      if (!this.adsEnabled) {
        pagesContainer.style.marginLeft = '0px'
        pageNavBut1.style.top = 'calc(50% + 44px)'
        pageNavBut2.style.top = 'calc(50% + 44px)'
        if (document.documentElement.clientWidth < 480) {
          prevPageBut.style.left = '10px'
        } else {
          prevPageBut.style.left = '30px'
        }
        return
      }
      var gptInt = document.getElementsByClassName('google-ad-interstitial')[0]
      if (!this.isDesktop()) {
        pagesContainer.style.marginLeft = '0px'
        // move the navigation button and interstitial ad up a bit if there is a bottom ad.
        pageNavBut1.style.top = 'calc(50% + 19px)'
        pageNavBut2.style.top = 'calc(50% + 19px)'
        gptInt.style.top = 'calc(50% + 19px)'
        if (document.documentElement.clientWidth < 480) {
          prevPageBut.style.left = '10px'
        } else {
          prevPageBut.style.left = '30px'
        }
      } else {
        pagesContainer.style.marginLeft = '300px'
        prevPageBut.style.left = '330px'
      }
    },
    displayInterstitialAd () {
      /* eslint-disable no-undef */
      if (this.settings === undefined || this.settings.gptAdCode === undefined || this.settings.gptAdCode === '') {
        return
      }
      let self = this
      googletag.cmd.push(function () {
        var sizeMap = googletag.sizeMapping().addSize([0, 0], []).addSize([320, 320], [300, 250]).addSize([320, 740], [[300, 250], [300, 600]]).build()
        if (self.isTabletLandscape()) {
          sizeMap = googletag.sizeMapping().addSize([0, 0], []).addSize([320, 320], [300, 250]).addSize([320, 740], [300, 250]).build()
        }
        self.adSlot = googletag.defineSlot('/7675/' + self.settings.gptAdCode + '/Welcome', [[300, 250], [300, 600]], 'div-gpt-ad-intersitial-1').setTargeting('atf', ['Y']).setTargeting('pkg', ['b']).defineSizeMapping(sizeMap).addService(googletag.pubads())
        googletag.pubads().enableSingleRequest()
        googletag.pubads().setTargeting('pl', ['vendor']).setTargeting('sect', ['CCi'])
        googletag.pubads().setCategoryExclusion('vendor')
        googletag.pubads().collapseEmptyDivs()
        googletag.enableServices()

        // googletag.pubads().addEventListener('impressionViewable', function(event) {
        //   if (event.slot == self.adSlot) {
        //     const activeSlide = self.$refs[self.swiper.activeIndex][0]
        //     return activeSlide.removeLoadingSpinner()
        //   }
        // });

        googletag.display('div-gpt-ad-intersitial-1')

        self.$eventHub.$emit('hideGoogleAdSide')

        // const activeSlide = self.$refs[self.swiper.activeIndex][0]
        // activeSlide.showLoadingSpinner()

        if (self.isDesktop()) {
          let ad = document.getElementById('div-gpt-ad-intersitial-1')
          ad.style.marginLeft = '150px'
        }
      })
      /* eslint-enable no-undef */
    },
    destroyInterstitialAd () {
      let self = this
      if (this.adSlot !== null) {
        googletag.cmd.push(function () {
          googletag.destroySlots([self.adSlot])
          self.adSlot = null
        })

        this.$eventHub.$emit('showGoogleAdSide')
      }
    },
    fullscreenChange () {
      let self = this
      setTimeout(function () {
        self.setHeightOfPagesContainer()
      }, 50)
    },
    createVirtualPageSlides () {
      var virtualSlidesData = []
      for (var i = 0; i < this.pages.length; i++) {
        virtualSlidesData.push(this.pages[i].firstPage.id)
      }
      return virtualSlidesData
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.didResize)
    window.removeEventListener('orientationchange', this.orientationDidChange)

    document.removeEventListener('keydown', this.checkKeyDown)
    document.removeEventListener('fullscreenchange', this.fullscreenChange)
    document.removeEventListener('mozfullscreenchange', this.fullscreenChange)
    document.removeEventListener('webkitfullscreenchange', this.fullscreenChange)
    document.removeEventListener('msfullscreenchange', this.fullscreenChange)

    if (this.swiper !== null) {
      this.swiper.destroy()
      this.swiper = null
    }
  },
  components: {
    CciPageSlide
  }
}
